import { useEffect } from "react";

import { logError } from "./log";

/**
 * Log an error for the event name. We only log once, regardless of subsequent payload or enabled changes.
 * This ensures that we don't repeatedly log due to shallow changes to the payload object,
 * even if the payload contents are stable.
 * We may adjust this in the future, by comparing the payload values against prior payload values.
 */

export function useLogErrorEffect(
  eventName: string,
  payload: {
    error: unknown;
    metadata?: Record<string, unknown>;
  },
  options?: { enabled?: boolean }
) {
  const { enabled = true } = options ?? {};

  useEffect(() => {
    if (enabled) {
      logError(eventName, payload);
    }
    // Intentionally not including payload in the dependency array, to ensure that we only log once.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventName, enabled]);
}
